export const DOMAIN_MISMATCH_ERROR = 'User.email not match any of the account email domains.';

const isRecord = (value: unknown): value is Record<string, unknown> =>
  typeof value === 'object' && value !== null;

export const isDomainMismatchError = (error: unknown): boolean => {
  if (!isRecord(error) || !isRecord(error.response)) return false;

  return (
    error.response.status === 400 &&
    Array.isArray(error.response.data) &&
    error.response.data.some((message) => message === DOMAIN_MISMATCH_ERROR)
  );
};

export const isHandledDomainMismatchError = (error: unknown): boolean => {
  if (!isRecord(error)) return false;

  return error.status === 400 && error.message === DOMAIN_MISMATCH_ERROR;
};
